import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiClient } from '../../core/api-client.service';
import { AdminDtRetInfo } from '../../super-admin/DTOs/admin-dt-ret-info';
import { DumbAdmin } from '../../super-admin/DTOs/dumb-admin';
import { GetAdminsRequest } from '../../super-admin/DTOs/get-admins-request';
import { SaveAdminRequest } from '../../super-admin/DTOs/save-admin-request';
import { DumbLiaison } from '../membership-management/DTOs/dumb-liaison';

@Injectable({
  providedIn: 'root'
})
export class MemberUserManagementService {
  readonly relativeBase = "member-admin-management/";

  constructor(private http: ApiClient) {

  }

  getAllMemberAdmins(request: GetAdminsRequest): Observable<AdminDtRetInfo> {
    return this.http.post(this.relativeBase + "get-all", request);
  }
  CreateNewMemberAdmin(request: SaveAdminRequest) {
    return this.http.put(this.relativeBase + "create", request);
  }
  UpdateMemberAdmin(request: SaveAdminRequest) {
    return this.http.post(this.relativeBase + "update", request);
  }
  SendAdminPasswordReset(contactId: string) {
    return this.http.post(this.relativeBase + "send-passord-reset/" + contactId, null);
  }



}
